export default __webpack_public_path__ + "static/media/team.e81374a2.svg";